import { useState, useRef } from "react";
import { X } from "lucide-react";
import axios from "axios";
import { toast } from "react-toastify";
const BASE_URL = process.env.REACT_APP_BASE_URL;
const AddNewReferenceFileModal = ({ isAddModalOpen, setIsAddModalOpen, fetchPublicationDetail,id, research_type }) => {
    const [file, setFile] = useState(null);
    const [loading, setLoading] = useState(false)
    const fileInputRef = useRef(null);
    const closeModal = () => {
        setIsAddModalOpen(false)
        setFile(null)
    };
    const handleFileChange = (e) => {
        if (e.target.files && e.target.files[0]) {
            setFile(e.target.files[0]);
        }
    };

    const handleDrop = (e) => {
        e.preventDefault();
        if (e.dataTransfer.files && e.dataTransfer.files[0]) {
            setFile(e.dataTransfer.files[0]);
        }
    };

    const handleDragOver = (e) => e.preventDefault();
    const handleUpdateFile = async () => {
        const formData = new FormData()
        // console.log("The file is:",file)
        // console.log("The id is:",id)
        formData.append('file', file)
        formData.append(research_type,id.toString())
        try {
            setLoading(true)
            const endpoints = {
                theoreticalidea: `${BASE_URL}/marketplace/researcher/theoreticalidea/create-referencefile`,
                labexperiment: `${BASE_URL}/marketplace/university/labexperiment/create-referencefile`,
                prototype: `${BASE_URL}/marketplace/researcher/prototype/create-referencefile`,
                industrialapplication: `${BASE_URL}/marketplace/researcher/industrialapplication/create-referencefile`,
                opportunity:`${BASE_URL}/marketplace/researcher/opportunity/create-referencefile`,
                labopportunity:`${BASE_URL}/marketplace/university/lab-opportunity/create-referencefile`,
                labtheoreticalidea: `${BASE_URL}/marketplace/university/lab-theoreticalidea/create-referencefile`,
                lab_labexperiment: `${BASE_URL}/marketplace/university/lab-experiment/create-referencefile`,
                labprototype: `${BASE_URL}/marketplace/university/lab-prototype/create-referencefile`,
                labindustrialapplication: `${BASE_URL}/marketplace/university/lab-industrialapplication/create-referencefile`,
            };
            const url = endpoints[research_type];
            if (!url) {
                console.warn("Unknown type:", research_type);
                return;
            }
            const res = await axios.post(`${url}/`, formData, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('access_token')}`,
                    'x-api-key': process.env.REACT_APP_X_API_KEY,
                },
            })
            if (res.status === 200 || res.status === 201) {
                alert('New file uploaded successfully!')
                fetchPublicationDetail()
                setIsAddModalOpen(false)
                setFile(null)
            }
        } catch (error) {
            console.log("Error while updating file", error)
            toast.error(error.code)
            setLoading(false)
        } finally {
            setLoading(false)
        }
    }
    return (
        <>
            {isAddModalOpen && (
                <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
                    {/* Modal Content */}
                    <div className="bg-white rounded-2xl shadow-xl w-full max-w-xl relative">
                        {/* Header */}
                        <div className="relative p-6 border-b border-gray-100">
                            <div className="flex items-center justify-between">
                                <div className="flex items-center gap-3">
                                    <div className="w-10 h-10 bg-[#e8f0f7] rounded-lg flex items-center justify-center">
                                        <svg className="w-5 h-5 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12" />
                                        </svg>
                                    </div>
                                    <div>
                                        <h2 className="text-lg font-semibold text-gray-900">Upload New File</h2>
                                        <p className="text-sm text-gray-500 mt-0.5">Upload a new file or drag drop</p>
                                    </div>
                                </div>
                                <button
                                    onClick={closeModal}
                                    className="absolute top-6 right-4 w-8 h-8 flex items-center justify-center rounded-lg hover:bg-gray-100 transition-colors"
                                >
                                    <X size={20} className="text-gray-500" />
                                </button>
                            </div>
                        </div>

                        {/* File display */}
                        <div className="p-6">
                            {(file) && (
                                <div className="relative mb-6 p-4 bg-gray-50 rounded-xl border border-gray-200">
                                    <div className="flex items-center gap-3">
                                        <div className="w-10 h-10 bg-white rounded-lg flex items-center justify-center flex-shrink-0">
                                            <svg className="w-5 h-5 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                                            </svg>
                                        </div>
                                        <div className="flex-1 min-w-0">
                                            <p className="text-sm font-medium text-gray-900 break-words max-w-full">
                                                {file && file.name}
                                            </p>
                                        </div>
                                    </div>
                                    {
                                        file && (
                                            <button
                                                onClick={() => setFile(null)}
                                                className="absolute top-1 right-1 bg-[#e8f0f7] p-1  w-8 h-8 flex items-center justify-center rounded-lg  transition-colors"
                                            >
                                                <X size={20} className="text-[#0f6abf]" />
                                            </button>
                                        )
                                    }

                                </div>
                            )}
                            {file && (
                                <div className="w-full flex items-center justify-center mt-3">
                                    <button
                                        onClick={handleUpdateFile}
                                        className=" w-full py-3 bg-[#0f6abf] text-white text-sm font-medium rounded-xl hover:bg-[#0a5ca8] transition-colors flex items-center justify-center gap-2 disabled:opacity-70 disabled:cursor-not-allowed"
                                        disabled={loading}
                                    >
                                        {loading ? (
                                            <>
                                                {/* Spinner loader */}
                                                <svg
                                                    className="animate-spin h-5 w-5 text-white"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    fill="none"
                                                    viewBox="0 0 24 24"
                                                >
                                                    <circle
                                                        className="opacity-25"
                                                        cx="12"
                                                        cy="12"
                                                        r="10"
                                                        stroke="currentColor"
                                                        strokeWidth="4"
                                                    ></circle>
                                                    <path
                                                        className="opacity-75"
                                                        fill="currentColor"
                                                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                                    ></path>
                                                </svg>
                                                Uploading File...
                                            </>
                                        ) : (
                                            <>
                                                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12" />
                                                </svg>
                                                Upload New File
                                            </>
                                        )}
                                    </button>
                                </div>
                            )}
                            {/* Drag & Drop Area */}
                            {

                                !file && (
                                    <div
                                        className="relative flex flex-col items-center justify-center border-2 border-dashed border-gray-300 rounded-2xl h-48 cursor-pointer hover:border-[#0f6abf] transition-colors group"
                                        onDrop={handleDrop}
                                        onDragOver={handleDragOver}
                                    >
                                        <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mb-4 group-hover:bg-[#e8f0f7] transition-colors">
                                            <svg
                                                className="w-8 h-8 text-gray-400 group-hover:text-[#0f6abf] transition-colors"
                                                fill="none"
                                                stroke="currentColor"
                                                viewBox="0 0 24 24"
                                            >
                                                <path
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeWidth="1.5"
                                                    d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12"
                                                />
                                            </svg>
                                        </div>

                                        <p className="text-gray-600 font-medium mb-1">
                                            Drag & Drop or Click to Upload New File
                                        </p>
                                        <p className="text-sm text-gray-500">
                                            Supported formats: PDF, DOC, IMG, etc.
                                        </p>

                                        <input
                                            id="fileInput"
                                            ref={fileInputRef}
                                            type="file"
                                            className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
                                            onChange={handleFileChange}
                                        />
                                    </div>
                                )
                            }

                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default AddNewReferenceFileModal;